<script lang="ts" setup>
import { computed } from 'vue'
import { cn } from '../lib/utils'

// two decimal precision: 10^2 = 100
const precisionMultiplier = 100

const props = defineProps<{
  amount?: number
  currency?: string
  prefix?: string
  oneSize?: boolean
  class?: string
  showColor?: boolean
}>()

const formattedAmount = computed(() => {
  return props.amount?.toLocaleString('nb-NO', {
    style: 'currency',
    currency: 'NOK',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  })
})
const formattedAmountSmall = computed(() => {
  return props.amount
    ?.toLocaleString('nb-NO', {
      style: 'currency',
      currency: 'NOK',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })
    .slice(0, -3)
})
const color = computed(() => {
  if (!props.showColor) return ''

  if (props.amount === 0) return 'gray'
  return props.amount < 0 ? 'red' : 'green'
})
</script>

<template>
  <span v-if="props.amount === undefined" :class="cn(color, props.class)">
    <span>-</span>
  </span>
  <span v-else-if="props.oneSize" :class="cn(color, props.class)">
    <span>{{ formattedAmount }}</span>
  </span>
  <span :class="props.class" v-else>
    <span id="big-text">{{ formattedAmountSmall }}.</span>
    <span id="small-text" :class="color"
      >{{ Math.abs(Math.floor(props.amount * precisionMultiplier)) % precisionMultiplier }} kr
    </span>
  </span>
</template>

<style scoped>
.gray {
  color: var(--badge-gray-text);
}
.green {
  color: var(--green);
}
.red {
  color: var(--red);
}
#big-text {
  font-size: 1.5rem;
}
#small-text {
  font-size: 1rem;
}
</style>
